import pwaScopes from "./pwaScopes.json";

// Fuente única de verdad de las PWAs. Este mismo JSON lo lee el script
// scripts/generate-pwa-html.js en el build, así que el scope que usa el
// runtime y el que queda en el HTML/manifest de cada PWA no pueden divergir.
export const PWA_SCOPES = pwaScopes;

export const DASHBOARD_KEY = "dashboard";

// Devuelve a qué "app" pertenece la URL: "montacargas", "cooler" o "dashboard".
// Se decide una sola vez, al cargar la página, a partir del path. Cada app
// monta SOLO su propio router (ver src/entries), así que desde una app no hay
// ruta que lleve a las otras.
export function getPwaKey(pathname = window.location.pathname) {
  const path = pathname.toLowerCase();

  const key = Object.keys(pwaScopes).find((candidate) => {
    const base = pwaScopes[candidate].scope.replace(/\/$/, "");
    return path === base || path.startsWith(`${base}/`);
  });

  return key || DASHBOARD_KEY;
}
